/**
 * @file     index.ts
 * @purpose  Barrel export for AddressAutocomplete component.
 */
export { AddressAutocomplete } from './AddressAutocomplete';
export type { StructuredAddress } from './AddressAutocomplete';
